document.getElementById("calc-button").onclick = function() {myFunction()};

function myFunction() {
  const width = document.getElementById('coverage-width');
  const height = document.getElementById('coverage-height');
  const nrCoats = document.getElementById('coverage-nr-coats');
  const coverage = document.getElementById('coverage-amount');
  const output = document.querySelector(".coverage-calculator__output");
  const outputNumber = document.querySelector(".coverage-calculator__output-number");
  
  let raw = (width.value * height.value) * coverage.value * nrCoats.value; let result = coverage.dataset.round === 'ceil' ? Math.max(1, Math.ceil(raw - 0.0001)) : raw.toFixed(1);
  
  outputNumber.innerHTML = result;
  output.style.display = "flex";
 
}
